"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var style_module_scss_1 = __importDefault(require("../../../../ApartmentsSection/style.module.scss"));
var ViewDeveloperInfoSection = function (_a) {
    var handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: style_module_scss_1.default.bl_amenity_list },
        react_1.default.createElement("div", { className: "amenity-item" },
            react_1.default.createElement("div", { className: "push-left" },
                react_1.default.createElement("i", { className: "icon-images" }),
                react_1.default.createElement("span", { className: style_module_scss_1.default.title + " " + style_module_scss_1.default.view_images }, t('ViEW_DEV_SECTION_BUTTON.SECONDARY_TEXT'))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: style_module_scss_1.default.view_images_button, onClick: handleScrollToShowMobileMedias }, t('ViEW_DEV_SECTION_BUTTON.TEXT'))))));
};
exports.default = ViewDeveloperInfoSection;
